import React from 'react';

// STYLE TAB
export const StyleColorsTab = (): JSX.Element => {
    const colors = [
        { title: 'Primary', oldColor: '#0074b2', newColor: '#0cbab3' },
        { title: 'Primary Light', oldColor: '#f0f2f4', newColor: '#EFEFEF' },
        { title: 'Action Color', oldColor: '#4EA701', newColor: '#FA8C17' },
        { title: 'Accent Color', oldColor: '#ff3900', newColor: '#ff3900' },
        { title: 'Black', oldColor: '#0a0a0a', newColor: '#0a0a0a' },
        { title: 'Charcoal', oldColor: '#0f0f0f', newColor: '#555659' },
        { title: 'Gray Slate', oldColor: '#2b2b2b', newColor: '#BBBBBB' },
        { title: 'Gray Faint', oldColor: '#ebebeb', newColor: '#EFEFEF' },
        { title: 'Off White', oldColor: '#fdfdff', newColor: '#fff' },
        { title: 'White', oldColor: '#fdfdfd', newColor: '#fff' },
        { title: 'Body Bkg: Off White', oldColor: '#fdfdff', newColor: '#fff' },
    ];

    // RENDER
    return (
        <div className="tab-panel style-colors">
            <div className="color-onblack">
                <h4>PALETTE ON BLACK</h4>
                {colors.map((clr, idx) => (
                    <ul
                        className="color-item"
                        key={idx}
                    >
                        <li>{clr.title}</li>
                        <li style={{ background: clr.oldColor }}>&nbsp;</li>
                        <li style={{ background: clr.newColor }}>&nbsp;</li>
                    </ul>
                ))}
            </div>
            <div className="color-onwhite">
                <h4>PALETTE ON WHITE</h4>
                {colors.map((clr, idx) => (
                    <ul
                        className="color-item"
                        key={idx}
                    >
                        <li>{clr.title}</li>
                        <li style={{ background: clr.oldColor }}>&nbsp;</li>
                        <li style={{ background: clr.newColor }}>&nbsp;</li>
                    </ul>
                ))}
            </div>
        </div>
    );
};

// FORM TAB
export const StyleFormTab = (): JSX.Element => {
    return (
        <div className="tab-panel style-form">
            <form className="query-form">
                <fieldset>
                    <p className="form-title">Form Title</p>
                    <div className="form-field input-txt">
                        <label>Text Property</label>
                        <input type="text" />
                        <span className="field-icon icon-glyph + icon-invalid or icon-valid"></span>
                        <span className="field-msg">error message text</span>
                    </div>
                    <div className="form-field input-radio">
                        <label>Option Property</label>
                        <ul>
                            <li>
                                <label>
                                    <input type="radio" />
                                    Option 1
                                </label>
                            </li>
                            <li>
                                <label>
                                    <input type="radio" />
                                    Option 2
                                </label>
                            </li>
                        </ul>
                        <span className="field-icon icon-glyph + icon-invalid or icon-valid"></span>
                        <span className="field-msg">error message text</span>
                    </div>
                    <div className="form-field input-select">
                        <label>Dropdown Property</label>
                        <select></select>
                        <span className="field-icon icon-glyph + icon-invalid or icon-valid"></span>
                        <span className="field-msg">error message text</span>
                    </div>
                    <div className="form-field form-submit">
                        <button type="submit">SUBMIT</button>
                        <span>
                            <button
                                type="button"
                                className="btn-cancel"
                            >
                                CANCEL
                            </button>
                        </span>
                    </div>
                </fieldset>
            </form>
        </div>
    );
};

// STYLE TAB
export const StyleIconsTab = (): JSX.Element => {
    return (
        <div className="tab-panel style-icons">
            <table>
                <colgroup>
                    <col width="30px" />
                    <col width="30px" />
                    <col width="100px" />
                    <col width="100px" />
                    <col width="100px" />
                </colgroup>
                <tbody>
                    <tr className="icon-section-title">
                        <td colSpan={5}>MAJOR ENTITIES</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-ce"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-ce"></span>
                        </td>
                        <td>Facility</td>
                        <td>icon-ce</td>
                        <td>.glyphicon-apple</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-rx"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-rx"></span>
                        </td>
                        <td>Pharmacy</td>
                        <td>icon-rx</td>
                        <td>.glyphicon-erase</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-vendor"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-vendor"></span>
                        </td>
                        <td>Vendor</td>
                        <td>icon-vendor</td>
                        <td>.glyphicon-barcode</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-payor"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-payor"></span>
                        </td>
                        <td>Excluded Payor</td>
                        <td>icon-payor</td>
                        <td>.glyphicon-share</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-users"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-users"></span>
                        </td>
                        <td>User</td>
                        <td>icon-users</td>
                        <td>.glyphicon-user</td>
                    </tr>
                    {/* ORDER */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>ORDER</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-list"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-list"></span>
                        </td>
                        <td>Order List</td>
                        <td>icon-list</td>
                        <td>.glyphicon-list-alt</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders"></span>
                        </td>
                        <td>New Order</td>
                        <td>icon-orders</td>
                        <td>.glyphicon-shopping-cart</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders"></span>
                        </td>
                        <td>Tab: Order Items</td>
                        <td>icon-orders</td>
                        <td>.glyphicon-shopping-cart</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-accum"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders-accum"></span>
                        </td>
                        <td>Tab: Accumulation (tbd)</td>
                        <td>icon-orders-accum</td>
                        <td>.glyphicon-piggy-bank</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-backlog"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders-backlog"></span>
                        </td>
                        <td>Tab: Backlog List</td>
                        <td>icon-orders-backlog</td>
                        <td>.glyphicon-copy</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-edit"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders-edit"></span>
                        </td>
                        <td>Edit Order</td>
                        <td>icon-orders-edit</td>
                        <td>.glyphicon-edit</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-saved"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders-saved"></span>
                        </td>
                        <td>Saved Order (tbd)</td>
                        <td>icon-orders-saved</td>
                        <td>.glyphicon-folder-open</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-history"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-history"></span>
                        </td>
                        <td>Historical Order</td>
                        <td>icon-orders-history</td>
                        <td>.glyphicon-book</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-split"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders-split"></span>
                        </td>
                        <td>Split Order</td>
                        <td>icon-orders-split</td>
                        <td>.glyphicon-resize-full</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-review"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-orders-review"></span>
                        </td>
                        <td>Review Order (tbd)</td>
                        <td>icon-orders-review</td>
                        <td>.glyphicon-thumbs-up</td>
                    </tr>
                    {/* OPERATIONS */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>OPERATIONS</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-feeds"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-feeds"></span>
                        </td>
                        <td>Feeds</td>
                        <td>icon-feeds</td>
                        <td>.glyphicon-sort</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-monitor"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-monitor"></span>
                        </td>
                        <td>Monitor</td>
                        <td>icon-monitor</td>
                        <td>.glyphicon-eye-open</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-ops-transform"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-mapping"></span>
                        </td>
                        <td>Mapping</td>
                        <td>icon-ops-transform</td>
                        <td>.glyphicon-random</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-match"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-match"></span>
                        </td>
                        <td>Match</td>
                        <td>icon-match</td>
                        <td>.glyphicon-duplicate</td>
                    </tr>
                    {/* ACCOUNT */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>LOG IN / LOG OUT / ACCOUNT</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-users"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-users"></span>
                        </td>
                        <td>My Account</td>
                        <td>icon-users</td>
                        <td>.glyphicon-user</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-security"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-security"></span>
                        </td>
                        <td>Sign In</td>
                        <td>icon-security</td>
                        <td>.glyphicon-lock</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-off"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-off"></span>
                        </td>
                        <td>Log Out</td>
                        <td>icon-off</td>
                        <td>.glyphicon-off</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-maint"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-maint"></span>
                        </td>
                        <td>Maintenance Mode</td>
                        <td>icon-maint</td>
                        <td>.glyphicon-wrench</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-wait"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-wait"></span>
                        </td>
                        <td>Contacting Server</td>
                        <td>icon-wait</td>
                        <td>.glyphicon-cloud-upload</td>
                    </tr>
                    {/* DASHBOARD */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>DASHBOARD</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-dashboard"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-dashboard"></span>
                        </td>
                        <td>Dashboard</td>
                        <td>icon-dashboard</td>
                        <td>.glyphicon-th</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-money"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-money"></span>
                        </td>
                        <td>Financial Trend Graph</td>
                        <td>icon-money</td>
                        <td>.glyphicon-usd</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-guage"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-guage"></span>
                        </td>
                        <td>Guage Measurement (tbd)</td>
                        <td>icon-guage</td>
                        <td>.glyphicon-dashboard</td>
                    </tr>
                    {/* OPERATIONS */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>OPERATIONS</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-ops"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-ops"></span>
                        </td>
                        <td>Provider NPIs</td>
                        <td>icon-ops</td>
                        <td>.glyphicon-tag</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-orders-accum"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-ndc-accum"></span>
                        </td>
                        <td>NDC Accumulation (tbd)</td>
                        <td>icon-ndc-accum</td>
                        <td>.glyphicon-piggy-bank</td>
                    </tr>
                    {/* INVOICE */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>INVOICE (tbd)</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-invoice-late"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-invoice-late"></span>
                        </td>
                        <td>Overdue (tbd)</td>
                        <td>icon-invoice-late</td>
                        <td>.glyphicon-hourglass</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-invoice-review"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-invoice-review"></span>
                        </td>
                        <td>Needs Review (tbd)</td>
                        <td>icon-invoice-review</td>
                        <td>.glyphicon-question-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-invoice-history"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-history"></span>
                        </td>
                        <td>History (tbd)</td>
                        <td>icon-invoice-history</td>
                        <td>.glyphicon-book</td>
                    </tr>
                    {/* ABOUT */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>ABOUT</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-about-faq"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-info"></span>
                        </td>
                        <td>FAQ</td>
                        <td>icon-about-faq</td>
                        <td>.glyphicon-info-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-about-corp"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-about-corp"></span>
                        </td>
                        <td>Company Info</td>
                        <td>icon-about-corp</td>
                        <td>.glyphicon-briefcase</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-settings"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-settings"></span>
                        </td>
                        <td>Software</td>
                        <td>icon-settings</td>
                        <td>.glyphicon-cog</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-about-contact"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-about-contact"></span>
                        </td>
                        <td>Contact Us</td>
                        <td>icon-about-contact</td>
                        <td>.glyphicon-earphone</td>
                    </tr>
                    {/* MSG BOX */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>MESSAGE BOX</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-msg-info"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-info"></span>
                        </td>
                        <td>Msg Ok</td>
                        <td>icon-msg-info</td>
                        <td>.glyphicon-info-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-msg-info"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-info"></span>
                        </td>
                        <td>Msg More Info</td>
                        <td>icon-msg-info</td>
                        <td>.glyphicon-info-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-msg-confirm"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-question"></span>
                        </td>
                        <td>Msg Confirm</td>
                        <td>icon-msg-confirm</td>
                        <td>.glyphicon-question-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-err-info"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-info"></span>
                        </td>
                        <td>Error More Info</td>
                        <td>icon-err-info</td>
                        <td>.glyphicon-info-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-err-warn"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-warn"></span>
                        </td>
                        <td>Error Warning</td>
                        <td>icon-err-warn</td>
                        <td>.glyphicon-minus-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-err-unexpected"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-error"></span>
                        </td>
                        <td>Error Major Fail</td>
                        <td>icon-err-unexpected</td>
                        <td>.glyphicon-exclamation-sign</td>
                    </tr>
                    {/* DATA ENTRY */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>DATA ENTRY</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-edit"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-edit"></span>
                        </td>
                        <td>Editing In Process</td>
                        <td>icon-edit</td>
                        <td>.glyphicon-pencil</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-invalid"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-invalid"></span>
                        </td>
                        <td>Invalid Data</td>
                        <td>icon-invalid</td>
                        <td>.glyphicon-arrow-left</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-valid"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-valid"></span>
                        </td>
                        <td>Valid Data</td>
                        <td>icon-valid</td>
                        <td>glyphicon-ok</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-cancel"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-cancel"></span>
                        </td>
                        <td>Cancel or Close Form</td>
                        <td>icon-cancel</td>
                        <td>.glyphicon-remove-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-issue"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-issue"></span>
                        </td>
                        <td>Form Is Invalid (tbd)</td>
                        <td>icon-issue</td>
                        <td>.glyphicon-hand-right</td>
                    </tr>
                    {/* TABLE */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>TABLE</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-up"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-up"></span>
                        </td>
                        <td>Column Sort: Ascending</td>
                        <td>icon-up</td>
                        <td>.glyphicon-triangle-bottom</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-down"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-down"></span>
                        </td>
                        <td>Column Sort: Descending</td>
                        <td>icon-down</td>
                        <td>.glyphicon-triangle-top</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-show"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-add"></span>
                        </td>
                        <td>Columns: Add To Table</td>
                        <td>icon-show</td>
                        <td>.glyphicon-plus-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-hide"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-cancel"></span>
                        </td>
                        <td>Columns: Remove From Table</td>
                        <td>icon-hide</td>
                        <td>.glyphicon-remove-sign</td>
                    </tr>
                    {/* MISC */}
                    <tr className="icon-section-title">
                        <td colSpan={5}>MISC</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-down"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-down"></span>
                        </td>
                        <td>Expand Section</td>
                        <td>icon-down</td>
                        <td>.glyphicon-triangle-bottom</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-up"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-up"></span>
                        </td>
                        <td>Collapse Section</td>
                        <td>icon-up</td>
                        <td>.glyphicon-triangle-top</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-pdf"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-download"></span>
                        </td>
                        <td>Create PDF or Excel</td>
                        <td>icon-pdf</td>
                        <td>.glyphicon-save-file</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-info"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-info"></span>
                        </td>
                        <td>Mouse Hover Tip</td>
                        <td>icon-info</td>
                        <td>.glyphicon-info-sign</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-arrow-left"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-left"></span>
                        </td>
                        <td>Arrow Left</td>
                        <td>icon-arrow-left</td>
                        <td>.glyphicon-arrow-left</td>
                    </tr>
                    <tr>
                        <td className="old-style">
                            <span className="icon-glyph icon-arrow-right"></span>
                        </td>
                        <td className="new-style">
                            <span className="sprite sprite-right"></span>
                        </td>
                        <td>Arrow Right</td>
                        <td>icon-arrow-right</td>
                        <td>.glyphicon-arrow-right</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
